import { useQuery } from '@tanstack/react-query';

import { fetchStockInfoForIDs } from '../api';

type UseQueryStockInfoForIds = {
    productIds: number[];
    storeId: number | undefined;
    isEnabled: boolean;
};

export const useQueryStockInfoForIds = ({
    productIds,
    storeId,
    isEnabled,
}: UseQueryStockInfoForIds) => {
    const queryKey = [
        'stock-info-for-ids',
        `productIds:${productIds.join(',')}`,
        `storeId:${storeId}`,
    ];

    const { data, error } = useQuery({
        queryKey,
        queryFn: () => fetchStockInfoForIDs({ productIds, storeId }),
        enabled: isEnabled,
        // staleTime – keep cache 1 hour - data is considered fresh for 1 hour,
        // and during this period, reusing the cache will not fetch new data.
        staleTime: 60 * 60 * 1000,
    });

    return { data, error };
};
